export default __webpack_public_path__ + "static/recyclace-6875abe9391f29f42b4eea91dedc44b6.jpg";